<!-- Assign Worker -->
<div class="modal right fade" id="firstLook" tabindex="-1" role="dialog" aria-labelledby="firstLookLabel">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="firstLookLabel">TELESKOP YENİLENDİ!</h4>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-12">
                        <p>Siz kullanıcılarımıza daha iyi bir kullanıcı deneyimi yaşatabilmek için arayüzümüzü yeniledik.</p>
                        <p>Yenilenen Arayüzümüz Hakkında Bilgi Almak İçin Bizimle İletişime Geçebilirsiniz.</p>
                    </div>
                </div>
            </div>
            <div class="modal-footer bg-light">
                <button type="submit" class="btn btn-primary" ng-click="firstLook()">Tamam</button>
            </div>
        </div>
    </div>
</div>
